import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { Header, Header2, Header3 } from '@app/components/general/header'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import { Address } from '@app/components/general/mailto'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import Trans from 'next-translate/Trans'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { SUPPORT_EMAIL } from '@app/configs/app-config'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/terms-of-service',
    }),
  }
}

function TermsOfService() {
  const { t } = useTranslation('terms-of-service')

  return (
    <MarketingDrawer>
      <SectionContainer container block>
        <Header>{t('header')}</Header>
        <time className='block pb-2' dateTime='2020-04-19T04:00:00.000Z'>
          {t('last-updated')}
        </time>
        <Paragraph>{t('header-b1')}</Paragraph>
        <Paragraph>{t('header-b2')}</Paragraph>
        <Header2>{t('accounts')}</Header2>
        <Paragraph>{t('accounts-details')}</Paragraph>
        <Header3>{t('linking')}</Header3>
        <Paragraph>{t('linking-details')}</Paragraph>
        <Header3>{t('termination')}</Header3>
        <Paragraph>{t('termination-details')}</Paragraph>
        <Header3>{t('govern')}</Header3>
        <Paragraph>{t('govern-details')}</Paragraph>
        <Header3>{t('changes')}</Header3>
        <Paragraph>{t('changes-details')}</Paragraph>
        <Header3 className='text-lg md:text-xl'>{t('contact')}</Header3>
        <Trans
          i18nKey='terms-of-service:contact-details'
          components={[
            <Paragraph key={'c1'} />,
            <Address email={SUPPORT_EMAIL} subject='TOS' body='👋' key={'c2'}>
              {SUPPORT_EMAIL}
            </Address>,
          ]}
        />
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { TermsOfService },
  {
    translation: 'terms-of-service',
  }
)
